package io.horion.cv.models

import kotlinx.serialization.Serializable

@Serializable
enum class PersonalizedSectionType {
    DESCRIPTION,
    ENTRIES,
    COMPETENCES,
    LIST
}